import React from "react";
/* eslint-disable */
import {
  Box, Card, Grid, CardContent, Divider, CardHeader,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';
import Chip from '@material-ui/core/Chip';


export default class ComponentToPrint extends React.Component {

  render() {
    const productData = this.props.priceNegotiation;
    const data = this.props.searchData;

    return (
      <div align='left' style={{ padding: '15px' }}>
        <h3><center><u>Price Negotiation Audit Report</u></center></h3>
        <div >&nbsp;</div>
        <div>&nbsp;</div>
        <Box minWidth={1200}>
          <TableContainer style={{ marginLeft: '5px' }}>
            <Table aria-label="caption table">
              <TableHead>
                <TableRow>
                  <TableCell align={'left'}>Proposed Date</TableCell>
                  <TableCell align={'left'}>Fresh Collection Center</TableCell>
                  <TableCell align={'left'}>Crop</TableCell>
                  <TableCell align={'right'}>Forecast Qty (Kg)</TableCell>
                  <TableCell align={'right'}>Forecast Remaining Qty (Kg)</TableCell>
                  <TableCell align={'right'}>Accepted Qty (Kg)</TableCell>
                  <TableCell align={'right'}>Remaining Qty (Kg)</TableCell>
                  <TableCell align={'right'}>Return Qty (Kg)</TableCell>
                  <TableCell align={'right'}>PP(LKR)</TableCell>
                  <TableCell align={'right'}>Second PP(LKR)</TableCell>
                  <TableCell align={'right'}>AP(LKR)</TableCell>
                  <TableCell align={'right'}>RP(LKR)</TableCell>
                  <TableCell align={'left'}>VPU Approved / Rejected User</TableCell>
                  <TableCell align={'left'}>FCC Approved / Rejected User</TableCell>
                  <TableCell align={'left'}>Harti Price Last Updated Date</TableCell>
                  <TableCell align={'left'}>Min</TableCell>
                  <TableCell align={'left'}>Max</TableCell>
                  <TableCell align={'left'}>Second PP Status</TableCell>
                  <TableCell align={'left'}>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {productData.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {new Date(row.priceProposedDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', minimumIntegerDigits: 2 })}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.factoryName}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.cropName}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {parseFloat(row.quantity).toFixed(2)}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.remainingQuantity.toFixed(2)}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.acceptedQuantity.toFixed(2)}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.remainQty.toFixed(2)}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.returnQuantity.toFixed(2)}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.proposedPrice.toFixed(2)}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.secondProposedPrice == 0 ? "-" : row.secondProposedPrice.toFixed(2)}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.approvedPrice == 0 ? "-" : row.approvedPrice.toFixed(2)}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.realizedPrice == 0 ? "-" : row.realizedPrice.toFixed(2)}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.vpuApprovedUser == null ? "-" : row.vpuApprovedUser}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.vccApprovedUser == null ? "-" : row.vccApprovedUser}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.date == '0' ? "-" : new Date(row.date).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', minimumIntegerDigits: 2 })}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.minPrice == 0 ? "-" : row.minPrice.toFixed(2)}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.maxPrice == 0 ? "-" : row.maxPrice.toFixed(2)}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.secondProposedPriceStatus == 0 ? <Chip label="Not Set" variant="outlined" />
                        : row.secondProposedPriceStatus == 1 ? <Chip label="Pending" variant="outlined" />
                          : row.secondProposedPriceStatus == 2 ? <Chip label="Approved" color="primary" />
                            : row.secondProposedPriceStatus == 3 ? <Chip label="Rejected" color="error" /> : "-"}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {row.status == 0 ? <Chip label="Not Set" variant="outlined" />
                        : row.status == 1 ? <Chip label="Pending" variant="outlined" />
                          : row.status == 2 ? <Chip label="Pending" variant="outlined" />
                            : row.status == 3 ? <Chip label="Approved" color="primary" />
                              : row.status == 4 ? <Chip label="Rejected" color="error" /> : "-"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>

    );
  }
}
